import React from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import { Header, Footer, AppRoutes, ScrollToTop, HighlighterBanner } from './components';
//import './styles/App.css';

function App() {
  return (
    <Router>
      <ScrollToTop />
      <HighlighterBanner />
      <Header />
      <AppRoutes />
      <Footer />
    </Router>
  );
}

export default App;
